import ProjectSettings from "./project-settings";

export default class ProjectSettings_ViewsAppSettings {

    public projectSettings  : ProjectSettings

    constructor(projectSettings:ProjectSettings, config:any) {
        this.projectSettings = projectSettings

        this._initFromConfig(config)
    }

    _initFromConfig(config:any) {
        _.forEach(config, (appSettings, projectViewId) => {
            // @ts-ignore
            this[projectViewId] = appSettings
        })
    }

    getConfig(viewId:ID) {
        return _.get(this, viewId.toString(), null)
    }

    setConfig(viewId:any, config:any) {
        // @ts-ignore
        this[viewId] = config
    }

    toJSON() {
        let result : any = {}
        const views = this.projectSettings.project.getInheritedViews();

        _.forEach(views, projectView=>{
            const projectViewId = projectView.id?.toString();
            // @ts-ignore
            if (this[projectViewId]) result[projectViewId] = this[projectViewId]
        })

        if (_.isEmpty(result)) result = null

        return result
    }

}
